export default {
  fields: {
    country: 'Bankens land',
    iban: 'IBAN',
    routing_number: 'Routingnummer',
    account_number: 'Kontonummer',
    sort_code: 'Sort code',
    account_type: 'Kontotype',
  },
  help: {
    country: 'Bankens land, som kan være et andet end restaurantens.',
  },
  placeholders: {
    iban: 'DE89 3704 0044 0532 0130 00',
  },
  formats: {
    uk_local: {
      title: 'Sort code og kontonummer',
      description: 'Den sædvanlige måde at angive en britisk konto på.',
    },
    iban: {
      title: 'IBAN',
      description: 'Det internationale bankkontonummer.',
    },
    us_local: {
      title: 'Routing- og kontonummer',
      description: 'En amerikansk bankkonto.',
    },
  },
  account_types: {
    checking: 'Checkkonto',
    savings: 'Opsparingskonto',
  },
  actions: {
    save: 'Gem bankkonto',
    cancel: 'Annuller',
    edit: 'Rediger',
  },
  card: {
    account: 'Konto',
    country: 'Land',
    status: 'Status',
  },
  statuses: {
    active: 'Aktiv',
    pending_verification: 'Under verificering',
    action_needed: 'Handling påkrævet',
    errored: 'Udbetaling mislykkedes',
    missing: 'Mangler',
  },
  notes: {
    pending_verification:
      'Adyen kontrollerer hver bankkonto, før udbetalinger starter. Bekræft den på Adyens side med et bank-login eller en kontoudskrift.',
    action_needed:
      'Betalingsudbyderen kunne ikke bekræfte denne bankkonto. Tjek oplysningerne, eller angiv en anden konto.',
    errored:
      'En udbetaling til denne konto mislykkedes, og udbetalinger er sat på pause. Tjek oplysningerne, eller angiv en anden konto.',
  },
};
